import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HubApiService } from '../../../services/hub.api.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { AssignTourModalData, AssignTourModalActions } from 'components/hub/assign.tour.modal/assign.tour.modal.provider';

@Component({
    templateUrl: './assign.tour.modal.component.html',
    styleUrls: ['./assign.tour.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AssignTourModalComponent extends BaseComponent {

    public data: any;

    constructor(private dialogRef: MatDialogRef<AssignTourModalComponent>,
                private actions: AssignTourModalActions,
                private formBuilder: FormBuilder,
                private hubApiService: HubApiService,
                data: AssignTourModalData,
    ) {
        super();
        this.data = Object.assign({}, data);

    }

    public close(): void {
        this.dialogRef.close();
    }


    public toggle(feed) {

    }

    public async confirm(event: ButtonTriggerEvent) {
        let regions = this.data.regions.filter(x => x.isInRegion).map(y => y.region.id);
        console.log(regions);
        this.hubApiService.assignTourToRegions(this.data.hubName, this.data.tourId, regions).subscribe(data => {
            this.actions.confirm(event, regions);
            this.dialogRef.close();
        });
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/assign.tour.modal/assign.tour.modal.component.ts